// Import DebugContext FIRST to set up fetch interceptor before any API calls
import './contexts/DebugContext';

import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(
  <App />
);
